const couponUrls = {
    getList: {
        url: '/coupons'
    },
    formOptions: {
        url: '/coupons/actions/formOptions'
    }
};

export default couponUrls;